module.exports = __webpack_public_path__ + "img/manuel.d4c3f65d.svg";